import React from "react";
import "./app.css";
import { getImage } from "../../../../../../utils/getImages";
const Mice3Card = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="col-md-12  py-5">
        <h1 className="title-color px-3 px-md-0 mt-10">
          {activetab === "english"
            ? cardData?.title
            : activetab === "simplified_chinese"
            ? cardData?.simplified_chinese_title
            : activetab === "arabic"
            ? cardData?.arabic_title
            : activetab === "bahasa"
            ? cardData?.bahasa_title
            : cardData?.traditional_chinese_title}
        </h1>
        <div
          id="icon-lists"
          className="row "
          style={{ marginTop: "20px" }}
        >
          {cardData?.dataArray?.map((item) => (
            <div className="col-3 col-md-3">
              <div>
                <img src={getImage(item?.image)} style={{width:"100%",height:"100%",objectFit:"cover"}} alt="" />
                <h5
                  style={{
                    color: " #2A3989",
                    fontWeight: "bold",
                    textAlign: "justify",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  {" "}
                  {activetab === "english"
                    ? item?.title
                    : activetab === "simplified_chinese"
                    ? item?.simplified_chinese_title
                    : activetab === "arabic"
                    ? item?.arabic_title
                    : activetab === "bahasa"
                    ? item?.bahasa_title
                    : item?.traditional_chinese_title}
                </h5>
                <p style={{ textAlign: "left" }} data-lang='{ "CN":"排⽔量" }'>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        activetab === "english"
                          ? item?.description
                          : activetab === "simplified_chinese"
                          ? item?.simplified_chinese_description
                          : activetab === "arabic"
                          ? item?.arabic_description
                          : activetab === "bahasa"
                          ? item?.bahasa_description
                          : item?.traditional_chinese_description,
                    }}
                  />
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Mice3Card;
